<div id="form-container">
    <div class="mat-subheading-2">
        Edit Settings
    </div>
    <div id="form-section">
        <form [formGroup]="courseForm" class="mat-white-bg">
            <mat-tab-group [selectedIndex]="0">
                <mat-tab label="General">
                  <div class="tab-content">
                    <div class="info-section">
                        <div>
                            <mat-form-field>
                                <input matInput placeholder="Title" formControlName="title" #titleInput maxlength="50">
                                <mat-hint align="end">{{titleInput.value?.length || 0}}/50</mat-hint>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <textarea matInput placeholder="Description" formControlName="description"></textarea>
                            </mat-form-field>
                        </div>
                      </div>
                      <div class="form-section">
                        <h4>Poster Image <mat-icon (click)="goToHelp('poster')" class="help-link">help</mat-icon></h4>
                        <div class="section poster-image">
                            <interactive-thumbnail [asset]="this.course.postermedia" [width]="'133px'" [height]="'74px'" (thumbnailClick)="onOpenFileManager()">
                            </interactive-thumbnail>
                        </div>
                      </div>
                      <!-- <ng-container formGroupName="information"> -->
                      <div class="form-section" formGroupName="information">
                        <h4>Navigation Options</h4>
                        <div class="checkbox-list">
                            <mat-checkbox class="checkbox" formControlName="displayOutline">Display Outline</mat-checkbox>
                            <mat-checkbox class="checkbox" formControlName="displayArrow">Display Arrow Navigation</mat-checkbox>
                        </div>
                        <h4>Device availability</h4>
                          <div class="checkbox-list device-list" formGroupName="deviceEnabled">
                            <mat-checkbox disabled class="checkbox" formControlName="desktop">Desktop</mat-checkbox>
                            <mat-checkbox class="checkbox" formControlName="mobile">Mobile & Tablet</mat-checkbox>
                            <mat-checkbox class="checkbox" formControlName="headset">VR Headset</mat-checkbox>
                        </div>
                    </div>
                </div>
            </mat-tab>
                <mat-tab label="Scoring">
                    <div class="tab-content">
                    <div class="form-section">
                        <h4>Scoring <mat-icon (click)="goToHelp('score')" class="help-link">help</mat-icon></h4>
                        <div class="informationForm form-column" formGroupName="information">
                          <div class="form-line">
                              <mat-checkbox #scoringEnabled class="checkbox first-checkbox" formControlName="scoringEnabled">Enable Scoring</mat-checkbox>
                              <mat-form-field class="score-input" [hidden]="!scoringEnabled.checked">
                                  <input  matInput formControlName="passingScore" placeholder="Passing Score" type="number">
                              </mat-form-field>
                          </div>
                          <div class="form-line additional-content" [hidden]="!scoringEnabled.checked">
                              <mat-checkbox #scoreAlertEnabled class="checkbox" formControlName="scoreAlertEnabled">Show alert when passing</mat-checkbox>
                              <mat-form-field class="message-input" [hidden]="!scoreAlertEnabled.checked">
                                  <input  matInput formControlName="scoreAlertMessage" placeholder="Message">
                              </mat-form-field>
                          </div>
                        </div>
                        <h4>Completion</h4>
                        <div class="form-subsection">
                            <div class="informationForm form-column" formGroupName="information">
                              <div class="form-line">
                                  <mat-checkbox #trackingEnabled class="checkbox first-checkbox" formControlName="trackingEnabled">Set completion scene</mat-checkbox>
                                  <scene-selector id="scene-selector" [hidden]="!trackingEnabled.checked" [course]="course" formControlName="endScene" [showNext]="false"></scene-selector>
                              </div>
                              <div class="form-line additional-content" [hidden]="!trackingEnabled.checked">
                                  <mat-checkbox #completionAlertEnabled class="checkbox" formControlName="completionAlertEnabled">Show alert when passing</mat-checkbox>
                                  <mat-form-field class="message-input" [hidden]="!completionAlertEnabled.checked">
                                      <input  matInput formControlName="completionAlertMessage" placeholder="Message">
                                  </mat-form-field>
                              </div>
                            </div>
                        </div>
                        <ng-container *ngIf="ltiEnabled">
                            <h4>LTI Options <mat-icon (click)="goToHelp('lti')" class="help-link">help</mat-icon></h4>
                            <div class="form-subsection">
                                <div class="informationForm form-column" formGroupName="information">
                                    <mat-radio-group
                                        formControlName="ltiGradeReport" (change)="setMaxScoreDefaultValue($event)">
                                        <mat-radio-button  value="scoreBasedGrade">
                                            <span class="radio-group-label">Send Score (Visible as percentage)</span>
                                            <mat-form-field class="score-input">
                                                <input  matInput formControlName="ltiMaxScore" placeholder="Maximum Score" type="number" >
                                            </mat-form-field>
                                            
                                        </mat-radio-button>
                                        <mat-radio-button  value="completionBasedGrade">
                                            <span class="radio-group-label">Send 100% on Completion</span>
                                        </mat-radio-button>
                                        </mat-radio-group>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                    </div>
                </mat-tab>
                <mat-tab label="Advanced">
                    <div class="tab-content">
                        <div class="form-section" *ngIf="!is360Only()">
                            <h4>Backlight <mat-icon (click)="goToHelp('backlight')" class="help-link">help</mat-icon></h4>
                            <div class="informationForm form-column" formGroupName="information">
                                <div class="form-line">
                                    <mat-checkbox #backlightEnabled class="checkbox first-checkbox" formControlName="backlightEnabled">Enable Backlight Effect</mat-checkbox>
                                </div>
                                <div *ngIf="backlightEnabled.checked" class="form-line additional-content">
                                    <mat-checkbox class="checkbox" formControlName="backlightActivatedPerDefault">Auto activate when experience starts</mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="form-section">
                            <h4>Advanced Publishing Options</h4>
                            <div class="informationForm form-column" formGroupName="information">
                                <div class="form-line" id="enable-versioning-container">
                                    <mat-checkbox #versioningEnabled
                                      [matTooltip]="getVersioningTooltipMessage()"
                                      class="checkbox first-checkbox"
                                      formControlName="versioningEnabled"
                                      [disabled]="!isVersioningAvailable()"
                                      [ngModel]="isVersioningAvailable() && course.information.versioningEnabled"
                                    >
                                        <span class="enable-versioning">
                                            Enable Versioning
                                        </span>
                                    </mat-checkbox>
                                    <div class="enable-versioning help-icon">
                                        <mat-icon (click)="blockEventAndGoToHelp($event, 'versioning')" class="help-link">help</mat-icon>
                                    </div>
                                </div>
                                <div [hidden]="!versioningEnabled.checked" class="form-line additional-content">
                                    <mat-checkbox class="checkbox" formControlName="saveProgressionEnabled"
                                    >Allow users to save their progression <span class="help-icon"><mat-icon (click)="blockEventAndGoToHelp($event, 'save-user-progress')" class="help-link">help</mat-icon></span></mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="form-section">
                            <h4>Allow Player contribution</h4>
                            <div class="informationForm form-column" formGroupName="information">
                                <div class="form-line" id="enable-ai-agent-edition-container">
                                    <mat-checkbox #displayAIAgentSettings
                                                  [matTooltip]="getContributionTooltips()"
                                                  class="checkbox first-checkbox"
                                                  formControlName="displayAIAgentSettingsEnabled"
                                                  [disabled]="!canEditAgentSettings()"
                                                  [ngModel]="canEditAgentSettings() && course.information.displayAIAgentSettingsEnabled"
                                    >
                                        <span class="enable-versioning">
                                            Display AI Character Settings
                                        </span>
                                    </mat-checkbox>
                                </div>
                            </div>
                            <div class="informationForm form-column" formGroupName="information">
                                <div class="form-line" id="enable-skybox-edition-container">
                                    <mat-checkbox [matTooltip]="getContributionTooltips()"
                                                  class="checkbox first-checkbox"
                                                  formControlName="editSkyboxEnabled"
                                                  [disabled]="!canEditSkyboxSettings()"
                                                  [ngModel]="canEditSkyboxSettings() && course.information.editSkyboxEnabled"
                                    >Allow Skybox Edition (Space Participants only)
                                    </mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <div class="form-section">
                            <h4>Import/Export Script <mat-icon (click)="goToHelp('translation')" class="help-link">help</mat-icon></h4>
                            <div>
                                <button mat-raised-button plan-limit [customTooltip]="'Upgrade to access this feature'" color="primary" (click)="downloadTranslationFile()">Export</button>
                                <button mat-raised-button plan-limit [customTooltip]="'Upgrade to access this feature'" (click)="uploadTranslationFile()">Import</button>
                                <input type="file" style="display: none;"
                                    (change)="onFileSelected($event)" #fileUpload>  
                            </div>
                            <span *ngIf="translationFileUploadSuccess" class="success"> Translation file successfully processed. The page will now reload...</span>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </form>
    </div>

    <div class="buttons">
        <button mat-button color="warn" (click)="this._dialogRef.close();"> CANCEL </button>
        <button mat-raised-button color="primary" (click)="saveAndCloseDialog()" [disabled]="courseForm.invalid">
            SAVE </button>
    </div>
</div>